import cn from 'classnames';

import { useUnit } from 'state/unit';
import useFormattable, { Formattable } from '../formattable';
import styles from './PodcastName.module.scss';

export interface PodcastNameProps
  extends Formattable<string>,
    Omit<React.HTMLAttributes<HTMLSpanElement>, 'children'> {
  className?: string;
}

const PodcastName: React.FC<PodcastNameProps> = (props) => {
  const { className, ...rest } = props;

  const unit = useUnit();
  const formattedValue = useFormattable(unit?.episode?.podcastName, props);

  return !unit ? null : (
    <span className={cn(styles.root, className)} {...rest}>
      {formattedValue}
    </span>
  );
};

export default PodcastName;
